import { Injectable, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response } from '@angular/http';
import { ConfigsService } from '../configs.service';

declare var swal;

@Injectable()
export class AutenticaService {

	private usuarioAutenticado: boolean = false;

	@Output() public mostrarMenuEmitter = new EventEmitter<boolean>();

	constructor( private rota: Router, private http: Http, private config: ConfigsService) { }
	
	// ################################################
	// FUNÇÃO PARA GRAVAR SESSÃO E FAZER A AUTENTICAÇÃO
	// ################################################
	fazerLogin(status, dados, hospital){
		if(status == 1){
			this.usuarioAutenticado = true;	
			this.mostrarMenuEmitter.emit(true);
			
			sessionStorage.setItem("autenticacao", JSON.stringify(dados));
			sessionStorage.setItem("hospital", JSON.stringify(hospital));

			this.rota.navigate(['/']);
		}else{
			this.usuarioAutenticado = false;
			this.mostrarMenuEmitter.emit(false);
			swal("Oops", "Login ou Senha Incorretos", "info");
		}
	}

	usuarioEstaAutenticado(){
		this.mostrarMenuEmitter.emit(true);
		return true;
	}
}



// WEBPACK FOOTER //
// ./src/app/login/autentica.service.ts